/* OMES — comportements partagés des pages Marque & Collection vendeur.
   Chargé par toutes les sections omes-vendor-*. Aucune dépendance. */
(function () {
  'use strict';

  /* 1. Compte à rebours : <span data-om-cd="d|h|m|s"> + data-om-countdown="ISO" sur la section */
  function tickAll() {
    document.querySelectorAll('[data-om-countdown]').forEach(function (root) {
      var end = new Date(root.getAttribute('data-om-countdown')).getTime();
      if (isNaN(end)) return;
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      var parts = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(parts).forEach(function (k) {
        root.querySelectorAll('[data-om-cd="' + k + '"]').forEach(function (el) {
          el.textContent = String(parts[k]).padStart(2, '0');
        });
      });
    });
  }

  /* 2. Filtres catégorie : boutons [data-om-filter="handle"], cartes [data-om-cat="handle"] */
  function bindFilters(scope) {
    scope.querySelectorAll('[data-om-filter]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var h = btn.getAttribute('data-om-filter');
        scope.querySelectorAll('[data-om-filter]').forEach(function (b) { b.classList.toggle('on', b === btn); });
        scope.querySelectorAll('[data-om-cat]').forEach(function (card) {
          card.style.display = (h === 'all' || card.getAttribute('data-om-cat') === h) ? '' : 'none';
        });
      });
    });
  }

  /* 3. Tri client : <select data-om-sort> agit sur le conteneur [data-om-grid] */
  function nameOf(card) {
    var el = card.querySelector('.nm');
    return (el ? el.textContent : card.textContent).trim();
  }

  function bindSort(scope) {
    scope.querySelectorAll('[data-om-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var grid = scope.querySelector('[data-om-grid]');
        if (!grid) return;
        var items = Array.prototype.slice.call(grid.children);
        var v = sel.value;
        items.forEach(function (el, i) { if (!el.dataset.omIndex) el.dataset.omIndex = i; });
        items.sort(function (a, b) {
          if (v === 'featured') return a.dataset.omIndex - b.dataset.omIndex;
          if (v === 'name') return nameOf(a).localeCompare(nameOf(b), 'fr');
          var pa = parseFloat(a.getAttribute('data-om-price') || '0');
          var pb = parseFloat(b.getAttribute('data-om-price') || '0');
          if (v.indexOf('asc') > -1 || v.indexOf('croissant') > -1) return pa - pb;
          if (v.indexOf('desc') > -1 || v.indexOf('décroissant') > -1) return pb - pa;
          return 0;
        });
        items.forEach(function (el) { grid.appendChild(el); });
      });
    });
  }

  function init() {
    document.querySelectorAll('.omes-vendor-section').forEach(function (scope) {
      if (scope.dataset.omInit) return;
      scope.dataset.omInit = '1';
      bindFilters(scope);
      bindSort(scope);
    });
    tickAll();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);   // éditeur de thème
  setInterval(tickAll, 1000);
})();
